import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import MoneyCard from "./MoneyCard";
import TimeCard from "./TimeCard";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import {bindActionCreators} from "redux";
import {loginAction} from "../../redux/modules/login";
import {connect} from "react-redux";
import Image from 'material-ui-image'
import {Link} from "react-router-dom";
import ContactUs from "./ContactUs";
import Divider from "@material-ui/core/Divider";
//import GridBase from "@material-ui/core/Grid";
import * as MainConstants from "../../utils/MainConstants";


/*const Grid = styled(GridBase)`
  .MuiGrid-root {
    flex-grow: 1;
  }*/

const Styles = theme => ({
  root: Object.assign({}, AppBackground, MediumFont),
  gridPane: {width: '50%', display: 'inline-block'},
  paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
  videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
  penInfoPanel: {color: 'white', fontSize: 20},
  penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
  videoPanel: {marginTop: 0},
  penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
  metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  metricInfo: Object.assign({}, AppBackground, ThinBorder)
  
});

const styles = theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: `${theme.spacing.unit * 3}px`,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'center',
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap',
    marginBottom: theme.spacing.unit,
  },
  divider: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
  rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
  margin: {
    margin: theme.spacing.unit * 2,
  },
  dividerColorPurpole: {
    //marginTop: theme.spacing.unit * 3,
    height: '20px',
    color:"#ffffff",
    //backgroundColor:"#760eb3",
  },
});


class SaveTime extends Component {
  
  state = {
    age: '',
    name: 'hai',
  };
  
  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };
  
  constructor(props) {
    super(props);
    this.towAgentClick = this.towAgentClick.bind(this);
    this.vehicleOwnerClick = this.vehicleOwnerClick.bind(this);
  }
  
  
  towAgentClick(){
    //alert("was called") ;
    this.props.towAgentConfigCall();
    
  }
  
  vehicleOwnerClick(){
    let { loginAction } = this.props;
    //this.props.auth.login();
    loginAction();
    //alert("was called") ;
    //this.props.vehicleOwnerConfigCall();
    
  }
  
  render() {
    const { classes, theme } = this.props;
    //const bull = <span className={classes.bullet}>•</span>;
    window.scrollTo(0, 0);
    return (
      <div id="top1"  style={{ backgroundColor:"#F2F6F8" }}>
        
        <Grid container spacing={24}  >
          <Grid   item xs={12} sm={12}  md={8} lg={8}   xl={8} >
            <div  style={{ marginLeft:10, marginTop:10}}>
              <Typography component="h4" variant="h5"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                {MainConstants.APPLICATION_NAME}&trade;
              </Typography>
              <Typography component="h1" variant="h4"   style = { { textAlign: 'left', alignSelf: 'left'  ,backgroundColor:'transparent' , color:'black'}} >For Vehicle Owner
              </Typography>
              <Typography component="h1" variant="h4"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'#e2580d'}} >
                ________________
              </Typography>
              
              <Typography component="h1" variant="h5"   style = { { textAlign: 'left', alignSelf: 'left'  , color:'black'}}gutterBottom>
                {/*<Text>As a vehicle owner, you will get notified by {MainConstants.APPLICATION_NAME}&trade; app, you can prevent your
                  vehicle being towed by paying the towing fee when you use the {MainConstants.APPLICATION_NAME}&trade; app.</Text>*/}
                As a vehicle owner, the {MainConstants.APPLICATION_NAME}&trade; app notifies you before your vehicle is towed, giving you the chance to prevent it by
                paying the towing fee directly through the app.
              </Typography>
              <Typography variant="h5"    component="h2" style = { {  color:'#BF360C' }}>
                Benefits:
              </Typography>
              
              <Typography   variant="subtitle1">
                <ul>
                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Save Time - </span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Avoid the trip to the tow yard by resolving the issue on the spot.</span> </li>
                  
                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Save Money - </span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Eliminate the cost of taxis or rideshares to retrieve your vehicle.</span> </li>
                  
                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Prevent Damage - </span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Since your vehicle isn’t towed, the risk of tow-related damage is significantly reduced.</span> </li>
                  
                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} >Avoid Insurance Increases - </span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>Fewer vehicle incidents mean less chance of premium hikes.</span> </li>
                  
                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Help the Environment - </span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Reducing unnecessary trips to and from tow lots cuts down on CO₂ emissions.</span> </li>
                  
                  
                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Roadside Assistance - </span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>   In the event of a breakdown, the {MainConstants.APPLICATION_NAME}&trade; app  connects you directly to our call center
                      for immediate support.</span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'#e2580d'}}></span>
                  </li>
                  
                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Parking Guidance - </span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Quickly locate and navigate to the nearest available parking lot.</span> </li>
                  
                  
                  <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Mobile App - </span>
                    <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Connect seamlessly with the {MainConstants.APPLICATION_NAME}&trade;  system  through the {MainConstants.APPLICATION_NAME}&trade; mobile app.  </span>
                    <div style={{display: 'flex', flexWrap: 'wrap' }}>
                      <div  style={{ marginRight:10, marginLeft:10, marginTop:10,  marginBotton:10, height:'20%', width:'15%'}}>
                        <Image
                          //src="/static/images/IMG_3615.JPG"
                          src="/static/images/TowWatchMobileB.png"
                          aspectRatio='(3/6)'
                        />
                      </div>
                      <div  style={{ marginRight:10, marginLeft:10, marginTop:10,  marginBotton:10, height:'20%', width:'15%'}}>
                        <Image
                          //src="/static/images/IMG_3615.JPG"
                          src="/static/images/TowWatchMobileB_1.png"
                          aspectRatio='(3/6)'
                        />
                      </div>
                      {/*}
                                                  <div  style={{ marginRight:10, marginLeft:10, marginTop:10,  marginBotton:10, height:'20%', width:'15%'}}>
                                                    <Image
                                                      //src="/static/images/IMG_3615.JPG"
                                                      src="/static/images/TowWatchMobileB_2.png"
                                                      aspectRatio='(3/6)'
                                                    />
                                                  </div>
                                                  <div  style={{ marginRight:10, marginLeft:10, marginTop:10,  marginBotton:10, height:'20%', width:'15%'}}>
                                                    <Image
                                                      //src="/static/images/IMG_3615.JPG"
                                                      src="/static/images/TowWatchMobileB_3.png"
                                                      aspectRatio='(3/6)'
                                                    />
                                                  </div>
                                                  <div  style={{ marginRight:10, marginLeft:10, marginTop:10,  marginBotton:10, height:'20%', width:'15%'}}>
                                                    <Image
                                                      //src="/static/images/IMG_3615.JPG"
                                                      src="/static/images/TowWatchMobileB_4.png"
                                                      aspectRatio='(3/6)'
                                                    />
                                                  </div>
                                                  */}
                    </div>
                  </li>
                
                
                </ul>
              </Typography>
              
              {/*<ul>
                                              <li><Link to="/home"> Go Back </Link></li>
                                              </ul>  */}
              <a href="/home"  rel="noreferrer">
                <Typography component="h1" variant="h6" style = { { color:'blue'}} >
                  &lArr; TowWatch Home
                </Typography>
              </a>
              
              
              {/*}
                                          <Card className={classes.card}   display="inline-block"  style = { {backgroundColor:'#f7f5f2', borderRadius:0, color:'red', width:"100%"}}>
                                        <CardContent>
                                      
                                          <Typography variant="h5"    component="h2" style = { {  color:'#BF360C' }}>
                                          Benefits:
                                            </Typography>
                                      
                                          <Typography   variant="subtitle1">
                                            <ul>
                                            <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Save Time - </span>
                                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> By not traveling to the tow company garage/storage to pick up your vehicle</span> </li>
                                      
                                          <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Save Money - </span>
                                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> By not paying a taxi or a rideshare for a ride to a tow company garage</span> </li>
                                      
                                          <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Prevent Damage - </span>
                                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Your vehicle does not get towed, the possibility of it being damaged is reduced</span> </li>
                                      
                                          <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} >Insurance Hike- </span>
                                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}>Reduce vehicle damage, reduce your insurance premimum hike</span> </li>
                                      
                                          <li style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}}><span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:20, color:'#e2580d'}} > Save Environment - </span>
                                          <span style = { { textAlign: 'left', alignSelf: 'left' , fontSize:18, color:'black'}}> Reducing the trips to and from the tow company lot, reduces the Co2 emissions</span> </li>
                                      
                                      
                                      
                                          
                                          </ul>
                                          </Typography>
                                          </CardContent>
                                          <CardActions>
                                          <div style = { { paddingLeft:50}}>
                                        <Button size="large"  variant="contained"  className={classes.button} onClick={this.vehicleOwnerClick}  style = { {textTransform:'none', backgroundColor:'white',fontSize:16, color:'red'}}  href="#basic-tabs" >Vehicle Owner Sign Up </Button>
                                        </div>
                                          </CardActions>
                                          </Card>  */}
            
            
            </div>
          </Grid>
          <Grid   item xs={12} sm={12}  md={4} lg={4}   xl={4}  >
            <div  style={{ marginRight:10, marginLeft:10, marginTop:10,  marginBotton:10}}>
              <Image
                //src="/static/images/IMG_3615.JPG"
                src="/static/images/tow1a.png"
                aspectRatio='(9/6)'
              />
            </div>
          </Grid>
          
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
            <Divider className={classes.dividerColorPurpole}></Divider>
            <div>
              <ContactUs> </ContactUs>
            </div>
          </Grid>
        
        </Grid>
      </div>
    
    
    );
  }
}

const mapStateToProps = (state) => {
  return {
  
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    loginAction:loginAction,
    
    
  }, dispatch);
};


SaveTime.propTypes = {
  classes: PropTypes.object.isRequired,
};
//export default BiomassView;
//export default withStyles(styles, { withTheme: true })(SaveTime);

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SaveTime));
